<style lang="scss" scoped>
#mainnav {
  z-index: 9;
}
#mainnav i.fa:hover {
  color: rgba(255, 255, 255, 0.7);
}
#mainnav .form-control {
  width: 10rem;
}
</style>

<template>
  <b-nav id="mainnav" class="module-nav text-center" vertical>
    <b-nav-item
      v-b-tooltip:hover.right.d400
      title="Register"
      :to="{name: 'register'}"
      @click="disableTT"
      @mouseleave="enableTT">
      <i class="fa fa-pencil-square-o" />
    </b-nav-item>

    <b-nav-item
      v-b-tooltip:hover.right.d400
      title="Profile"
      :to="{name: 'profile'}"
      @click="disableTT"
      @mouseleave="enableTT">
      <i class="fa fa-table" />
    </b-nav-item>

    <b-nav-item
      v-b-tooltip:hover.right.d400
      :href="nda"
      title="Pre-Release Agreement Template"
      @click="disableTT"
      @mouseleave="enableTT">
      <i class="fa fa-file-pdf-o" />
    </b-nav-item>

    <b-nav-item-dropdown no-caret>
      <div
        slot="button-content"
        v-b-tooltip:hover.right.d400
        title="Send Pre-Release Agreement"
        @click="disableTT"
        @mouseleave="enableTT">
        <i class="fa fa-envelope-o" />
      </div>

      <b-dd-header>Simcenter 3D</b-dd-header>
      <template v-for="e in eventsOpen.s3d" v-if="e.test.mode == null || e.test.mode == 'SHOW'">
        <b-dd-item @click="mailto(e)">
          {{ e.name }}
        </b-dd-item>
      </template>
    </b-nav-item-dropdown>

    <!-- admin -->
    <b-nav-item
      v-show="admin"
      v-b-tooltip:hover.right.d400
      class="mt-auto"
      title="Tester Info/PR List"
      :to="{name: 'testers', params: {}}"
      @click="disableTT"
      @mouseleave="enableTT">
      <i class="fa fa-search" />
    </b-nav-item>

    <b-nav-item
      v-show="admin"
      v-b-tooltip:hover.right.d400
      title="Dashboard"
      :to="{name: 'dashboard'}"
      @click="disableTT"
      @mouseleave="enableTT">
      <i class="fa fa-table" />
    </b-nav-item>
<!--
    <b-nav-item
      v-show="admin"
      v-b-tooltip:hover.right.d400
      title="Reports"
      :to="{name: 'reports'}"
      @click="disableTT"
      @mouseleave="enableTT">
      <i class="fa fa-file-excel-o" />
    </b-nav-item>
 -->   
   
    <b-nav-item-dropdown v-show="admin" dropup no-caret>
      <div slot="button-content" v-b-tooltip:hover.right.d400 title="Reports" @click="disableTT" @mouseleave="enableTT">
        <i class="fa fa-file-excel-o" />
      </div>

      <b-dd-header>Simcenter 3D</b-dd-header>
      <template v-for="e in eventsOpen.s3d">
        <b-dd-item :href="csv(e.id)">
          {{ e.name }}
        </b-dd-item>
      </template>

      <b-dd-divider />
      <b-dd-header>Archived</b-dd-header>
      <template v-for="e in eventsClosed">
        <b-dd-item :href="csv(e.id)">
          {{ e.name }}
        </b-dd-item>
      </template>
    </b-nav-item-dropdown>


    <b-nav-item-dropdown :class="{'mt-auto': !admin}" dropup no-caret>
      <div slot="button-content" v-b-tooltip:hover.right.d400 title="Help" @click="disableTT" @mouseleave="enableTT">
        <i class="fa fa-question-circle" />
      </div>

      <b-dd-text>Release {{ ver }}</b-dd-text>
      <b-dd-divider />

      <b-dd-header>Contact</b-dd-header>
      <b-dd-item href="mailto:tac_mis.plm@siemens.com"> tac_mis.plm@siemens.com </b-dd-item>
    </b-nav-item-dropdown>

    <b-nav-item v-b-tooltip:hover.right.d400 href="webkey_auth/logout.php5" title="Log out">
      <i class="fa fa-sign-out" />
    </b-nav-item>
  </b-nav>
</template>

<script>
import {orderBy} from 'lodash'
import {mapState, mapGetters} from 'vuex'
import helper from '@/lib/helper'
import api from '@/lib/api'

export default {
  data() {
    return {
      show: true,
      admin: helper.admin(),
      nda: api.nda.template('D01'),
      ver: process.env.VUE_APP_VERSION,
    }
  },
  computed: {
    ...mapState(['webkey']),
    ...mapGetters(['events']),
    eventsOpen() {
      const m = {}

      m.s3d = orderBy(
        this.events.filter((x) => x.closed == 0 && x.test.product == 'S3D'),
        'name'
      )

      return m
    },
    eventsClosed() {
      const a = this.events.filter((x) => x.closed == 1)
      return orderBy(a, 'name')
    },
  },
  methods: {
    disableTT() {
      this.$root.$emit('bv::disable::tooltip')
      this.$root.$emit('bv::hide::tooltip')
    },
    enableTT() {
      helper.sleep(200)
      this.$root.$emit('bv::enable::tooltip')
    },
    mailto(event) {
      let s = event.mail.to.join(';')

      if (event.mail.cc.length > 0) {
        s += `?cc=${event.mail.cc.join(';')}`
      }
      window.location.href = `mailto:${s}`
    },
    csv(eid) {
      return api.request.csv(eid)
    },
  },
}
</script>
